import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamJAPJ() {
  
  return (
    <div className={styles["declaration"]}>
      <h1>フィールドフォースメンバーのトレーニングと試験に関するコンプライアンス声明</h1>

      <p>
        フロントラインの第三者プロモーターのサービスの質を継続的に強化するため、Xiaomi国際部門トレーニングチーム（以下、「私たち」または「当社」）は、アウトソーシングサービスプロバイダーによって指名された第三者プロモーター（以下、「研修生」）向けにトレーニングコースと知識強化試験を提供しています。トレーニングと試験は、コースの内容を最適化して、学習結果を統合することを目標としており、いかなる形式の労働関係や実際の管理行動も構成しません。以下は、トレーニングと試験に関する声明です。
      </p>

      <ol>
        <li>
          <strong>トレーニングと試験の性質</strong><br/>
          トレーニングコースと試験はすべて、知識の共有を目的に実施され、研修生が体系的に製品情報とサービス基準などを理解できるよう支援することをめざしています。試験結果は、トレーニングの内容に関する研修生の理解のみを反映するもので、業績評価の根拠にはならないものとします。私たちには、アウトソーシングサービスプロバイダーの業績評価や給与配分、または研修生に関する他の雇用関係の問題に対する権限はなく、これを妨害することもありません。
        </li>
        <li>
          <strong>法的な関係の明確化</strong><br/>
          研修生とそれぞれのアウトソーシングサービスプロバイダーの間の雇用主と被雇用者の関係は、このトレーニングおよび試験プログラムの影響を受けません。当社と研修生の間に雇用主と被雇用者の関係はなく、この知識共有トレーニングおよび試験プログラムが研修生の事実上の雇用関係を成立させるものでもありません。雇用のあらゆる権利と義務は、アウトソーシングサービスプロバイダーと研修生の間にのみ存在します。
        </li>
        <li>
          <strong>試験結果の使用</strong><br/>
          試験結果は以下の目的でのみ使用されるものとします：
          <ol type="1">
            <li>当社の社内コースの最適化と改善の参考にします；</li>
            <li>アウトソーシングサービスプロバイダーの独立した判断と意思に基づき、研修生の専門的な適性の証明としてアウトソーシングサービスプロバイダーに提供します；</li>
            <li>試験結果は公表されず、第三者に開示されることもありません。</li>
          </ol>
        </li>
      </ol>

      <p>
        この声明は、発行日から有効になるものとします。トレーニングおよび試験プログラムに参加すると、研修生はこの声明を承認して受諾したものとみなされます。当社は本声明を解釈する権利を保有し、時折、本声明を修正する可能性があります。ただし、修正を行っても、雇用ではないというこのトレーニングと試験の性質を変えるものではありません。異なる言語バージョン間で争議や齟齬が発生した場合は、英語版が優先されるものとします。
      </p>

      <div className={styles["footer"]}>
        Xiaomi国際部門トレーニングチーム<br/>
        日付：{getLocalizedTime('ja-JP')}
      </div>
    </div>
  );
}